import { render, staticRenderFns } from "./MartixChoice.vue?vue&type=template&id=3247ed38&scoped=true"
import script from "./MartixChoice.vue?vue&type=script&lang=js"
export * from "./MartixChoice.vue?vue&type=script&lang=js"
import style0 from "./MartixChoice.vue?vue&type=style&index=0&id=3247ed38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247ed38",
  null
  
)

export default component.exports